import { createContext, useContext } from 'react'

export interface ToastContextValue {
  /** Fire-and-forget toast, auto-dismissed after ~2.5s (like the iOS toasts). */
  showToast: (message: string, kind?: 'success' | 'error') => void
}

export const ToastContext = createContext<ToastContextValue | null>(null)

export function useToast(): ToastContextValue {
  const context = useContext(ToastContext)
  if (!context) throw new Error('useToast must be used within a ToastProvider')
  return context
}
